module.exports = __webpack_public_path__ + "static/media/worker_idle.cf20ca77.svg";